import QuestionLabel from '~/components/forms/questions/QuestionLabel';
import React from 'react';
import FileUpload from '~/components/FileUpload';

const FileUploadQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div>
                <FileUpload value={value} onChange={setValue} showName={true} />
            </div>
        </label>
    );
};

export default FileUploadQuestion;
